import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getImageUrl } from "utils/imageHelper";
import { useArticles } from "components/articles/hooks/useArticles";
import ImageViewer from "components/common/ImageViewer";

export default function ViewArticle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data,loadArticleById } = useArticles();

  const [article, setArticle] = useState(null);

  const [viewerOpen, setViewerOpen] = useState(false);
  const [activeMedia, setActiveMedia] = useState(null);
  

useEffect(() => {
  const fetchArticle = async () => {
    try {
      const res = await loadArticleById(id);
      setArticle(res?.data);
    } catch (err) {
      console.error("Failed to load article:", err);
    }
  };

  fetchArticle();
}, [id]);

if (!article) {
  return (
    <div className="p-6">
      <p>Loading article...</p>
    </div>
  );
}


  

  const formatDateTime = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    const pad = (n) => String(n).padStart(2, "0");

    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(
      d.getUTCDate()
    )}, ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(
      d.getUTCSeconds()
    )}`;
  };

  return (
    <div className="p-6 space-y-8">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Article Details</h1>
        <button
          onClick={() => navigate(-1)}
          className="rounded-xl border px-4 py-2"
        >
          Back
        </button>
      </div>

      <Card title="Article Information">
        <Info label="Title" value={article.title} />
        <Info label="Author" value={article.author} />
        <Info label="Company ID" value={article.company_id} />
        <Info label="Exhibitor" value={article.exhibitor_id?.title} />
        <Info label="Status" value={article.status} />
        <Info label="Description" value={article.description} />
        <Info label="Published Date" value={formatDateTime(article.published_date)} />
        {/* <Info label="Created At" value={formatDateTime(article.createdAt)} />
        <Info label="Updated At" value={formatDateTime(article.updatedAt)} />
        <Info label="Created By" value={article.created_by} /> */}
      </Card>

      {article.articleImages?.length > 0 && (
        <Card title="Article Images">
          <div className="flex flex-wrap gap-4">
            {article.articleImages.map((img, index) => {
              const isDefault =
                article.default_media?.mediaType === "image" &&
                article.default_media?.value === img;

              return (
                <div
                  key={index}
                  className={`relative border rounded-xl p-1 ${
                    isDefault ? "ring-2 ring-brand-500" : ""
                  }`}
                >
                  <img
                    src={getImageUrl(img)}
                    alt="Article"
                    className="h-32 w-48 object-cover rounded-lg cursor-pointer"
                    onClick={() => {
                      setActiveMedia(img);
                      setViewerOpen(true);
                    }}
                  />
                  {isDefault && (
                    <p className="text-xs text-brand-500 text-center mt-1">
                      Default
                    </p>
                  )}
                </div>
              );
            })}
          </div>

          <ImageViewer
            open={viewerOpen}
            onClose={() => setViewerOpen(false)}
            src={getImageUrl(activeMedia)}
          />
        </Card>
      )}


      {article.articleVideos?.length > 0 && (
        <Card title="Article Videos">
          <div className="flex flex-wrap gap-4">
            {article.articleVideos.map((video, index) => {
              const isDefault =
                article.default_media?.mediaType === "video" &&
                article.default_media?.value === video;

              return (
                <div
                  key={index}
                  className={`relative border rounded-xl p-2 ${
                    isDefault ? "ring-2 ring-brand-500" : ""
                  }`}
                >
                  <video
                    src={getImageUrl(video)}
                    controls
                    className="h-40 w-64 rounded-lg"
                  />
                  {isDefault && (
                    <p className="text-xs text-brand-500 text-center mt-1">
                      Default
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </Card>
      )}

      {/* {article.default_media && (
        <Card title="Default Media Info">
          <Info label="Type" value={article.default_media.type} />
          <Info label="Media Type" value={article.default_media.mediaType} />
          <Info label="Value" value={article.default_media.value} />
        </Card>
      )} */}
    </div>

  );
}


function Card({ title, children }) {
  return (
    <div className="rounded-[20px] bg-white p-6 shadow-3xl">
      <h3 className="mb-4 text-lg font-semibold">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {children}
      </div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <p className="text-sm text-gray-500">{label}</p>
      <p className="font-medium break-words">{value || "-"}</p>
    </div>
  );
}
